import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=29ec32f6&scoped=true&"
import script from "./detail-content.vue?vue&type=script&lang=js&"
export * from "./detail-content.vue?vue&type=script&lang=js&"
import style0 from "./detail-content.vue?vue&type=style&index=0&id=29ec32f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec32f6",
  null
  
)

export default component.exports